import axios from 'axios'
import env from "react-dotenv"

const endpoint = `${env.WHATSAPP_API}`

export const WhatsAppService = {

    getStatus(token) {
        return axios.get(`${endpoint}/connection/status?token=${token}`)
    },

    startConnection(token) {
        return axios.post(`${endpoint}/connection/start`, { token })
    },

    disconnect(token) {
        return axios.delete(`${endpoint}/disconnect?token=${token}`)
    },

    sendMessage(data) {
        return axios.post(`${endpoint}/sendmessage`, {
            ...data,
            idempotencyKey: data.idempotencyKey || `frontend_${Date.now()}_${Math.random()}`
        })
    }

}